import GS from '../../../grafsync/grafsync';
import { handleResponse } from './handleResponse';

function currentUser() {
    return JSON.parse(localStorage.getItem('currentUser'));
}

async function login(username, password) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // Store jwt token and user ID in local storage to keep user logged in between page refreshes
            const storeUser = {
                id: user.id,
                token: user.token
            };
            localStorage.setItem('currentUser', JSON.stringify(storeUser));
            return user;
        });
}

async function forgottenPassword(username) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username }),
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate/forgotten`, requestOptions)
        .then(handleResponse);
}

async function forgottenUsername(email) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate/forgottenusername`, requestOptions)
        .then(handleResponse);
}

async function resetPassword(password, token) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "Bearer " + token
        },
        body: JSON.stringify({ password }),
        mode: 'cors',
        cache: 'no-cache'
    };
    return fetch(`${process.env.REACT_APP_API_URL}/authenticate/resetpassword`, requestOptions)
        .then(handleResponse);
}

async function logout(isSSOuser = false) {
    // Remove user from local storage
    localStorage.removeItem('currentUser');
    let logoutData;
    try {
        // Now logout user at API layer
        logoutData = await GS.logout();
    }
    catch (e) {
        console.log(e)// eslint-disable-line    
        logoutData = null;
    }
    // Clean up the application
    await GS.exit();
    const ssoEnabled = window.Graphologi.sso;
    // If we're already logged out logoutData might be null
    if (ssoEnabled && isSSOuser && logoutData) {
        const logoutURL = logoutData.logoutURL;
        // Finally log out of SSO it applicable
        window.location.href = logoutURL;
    }
}

export const authenticationService = {
    login,
    logout,
    forgottenPassword,
    forgottenUsername,
    resetPassword,
    get currentUser() { return currentUser(); }
};
